import { useSelector } from "react-redux"
import { StatusPill as Pill, toneOfColor } from "../../../components/ui/status-pill"
import { IGeneral } from "../../../store/General"

type CatalogEntry = { code: string; name?: string; sentName?: string | null; color?: string | null }

type Props = {
  code: string | null | undefined
  pick: (s: IGeneral) => CatalogEntry[]
  labelField?: "name" | "sentName"
}

/** Soft dot pill for the sales list (canvas Ord_SalesList): tinted background + coloured dot, dark text. */
export function StatusPill({ code, pick, labelField = "name" }: Props) {
  const catalog = useSelector((s: { general: IGeneral }) => pick(s.general)) ?? []
  const entry = catalog.find((c) => c.code === code)
  const label = (labelField === "sentName" ? entry?.sentName : entry?.name) ?? "-"
  return <Pill tone={entry ? toneOfColor(entry.color) : "gray"}>{label}</Pill>
}

export const orderStatusPill = (code: string | null | undefined) => (
  <StatusPill code={code} pick={(g) => g.orderStatus as CatalogEntry[]} labelField="sentName" />
)
export const paymentStatusPill = (code: string | null | undefined) => (
  <StatusPill code={code} pick={(g) => g.paymentStatus as CatalogEntry[]} />
)
